import React, { useCallback } from 'react';

import { FormattedMessage } from 'react-intl-next';

import { cssMap, cx } from '@atlaskit/css';
import { Flex, Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { ITEM_FIELDS } from '../../../types';
import type { UpdateItemFormFieldType } from '../../items-shared/types';
import { MediaPickerSection, type SelectedImage, type UploadedImage } from '../../media-components';

import { messages } from './messages';

const styles = cssMap({
	fieldWrapper: {
		marginTop: token('space.200'),
	},
});

type ImageFieldProps = {
	analyticsSource: string;
	contentId: string;
	imageAltText?: string;
	imageSrc?: string;
	itemId: string;
	shouldAllowLinkFromUrl?: boolean;
	updateItemFormField: UpdateItemFormFieldType;
};

export const ImageField = ({
	analyticsSource,
	itemId,
	contentId,
	imageSrc,
	imageAltText,
	updateItemFormField,
	shouldAllowLinkFromUrl = false,
}: ImageFieldProps): React.JSX.Element => {
	const handleChangeImage = useCallback(
		(props: SelectedImage | UploadedImage) => {
			const newImageSrc =
				'fullSizeImageUrl' in props ? props.fullSizeImageUrl : props.uploadedImageId;
			const newAltText = props.altDescription;

			updateItemFormField(itemId, {
				[ITEM_FIELDS.IMAGE_SRC]: newImageSrc,
				[ITEM_FIELDS.IMAGE_ALT_TEXT]: newAltText,
			});
		},
		[itemId, updateItemFormField],
	);
	return (
		<Flex xcss={cx(styles.fieldWrapper)} direction="column">
			<Inline spread="space-between" alignBlock="center" testId="image-field">
				<Text>
					<FormattedMessage {...messages.imageLabel} />
				</Text>
				<MediaPickerSection
					shouldAllowLinkFromUrl={shouldAllowLinkFromUrl}
					contentId={contentId}
					image={imageSrc ? { imageSrc, altText: imageAltText } : undefined}
					onChangeImage={handleChangeImage}
					analyticsSource={analyticsSource}
					shouldShowDeleteButton
				/>
			</Inline>
		</Flex>
	);
};
